import React from 'react';

import styled from '@emotion/styled';

import { ITrackPackageResponse } from '../../../models/trackPage/trackPackage.model';

interface IMoreShipmentDetails {
 trackingInfo?: ITrackPackageResponse;
}

const MoreShipmentDetails: React.FC<IMoreShipmentDetails> = ({
 trackingInfo,
}) => {
 return (
  <Container>
   <Title>More Shipment Details</Title>
   <DetailsGrid>
    <DetailsGridLeft>
     {trackingInfo?.shippingStatus === 'DELIVERED' && (
      <DetailItem>
       <DetailLabel>Delivered</DetailLabel>
       <DetailValue>{trackingInfo?.scheduledDeliveryDate || 'N/A'}</DetailValue>
      </DetailItem>
     )}
     <DetailItem>
      <DetailLabel>Delivery Address</DetailLabel>
      <DetailValue>{trackingInfo?.address || 'N/A'}</DetailValue>
     </DetailItem>

     <DetailItem>
      <DetailLabel>Receiver Name</DetailLabel>
      <DetailValue>{trackingInfo?.receiverName || 'N/A'}</DetailValue>
     </DetailItem>
     {trackingInfo?.shippingStatus === 'DELIVERED' && (
      <DetailItem>
       <DetailLabel>Received On</DetailLabel>
       <DetailValue>{trackingInfo?.scheduledDeliveryDate || 'N/A'}</DetailValue>
      </DetailItem>
     )}
    </DetailsGridLeft>
    <DetailsGridRight>
     <DetailItem>
      <DetailLabel>Parcel ID</DetailLabel>
      <DetailValue>{trackingInfo?.packageId || 'N/A'}</DetailValue>
     </DetailItem>
    </DetailsGridRight>
   </DetailsGrid>
  </Container>
 );
};

export default MoreShipmentDetails;

const Container = styled.div`
 border: 1px solid ${({ theme }) => theme.palette.borderColor};
 border-radius: 10px;
 display: flex;
 flex-direction: column;
 margin-top: 12px;
 overflow: clip;
`;

const Title = styled.div`
 font-size: 22px;
 color: #000000;
 font-weight: 600;
 padding: 18px;
 background-color: #fafafa;
 border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

const DetailsGrid = styled.div`
 display: grid;
 padding: 16px 0px;
 grid-template-columns: 1fr 1fr;

 @media (max-width: 768px) {
  grid-template-columns: 1fr;
  gap: 16px;
 }
`;

const DetailsGridLeft = styled.div`
 padding: 0px 18px;
 grid-template-columns: 1fr;
 gap: 16px;
 border-right: 1px solid ${({ theme }) => theme.palette.borderColor};

 @media (max-width: 768px) {
  border-right: 0px solid ${({ theme }) => theme.palette.borderColor};
 }

 & > :nth-last-child(1) {
  border-bottom: none !important;
 }
`;

const DetailsGridRight = styled.div`
 padding: 0px 18px;
  grid-template-columns: 1fr;
  gap: 16px;
 }
`;

const DetailItem = styled.div`
 display: flex;
 align-items: center;
 justify-content: space-between;
 border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
 padding: 12px 0px;
`;

const DetailLabel = styled.div`
 font-size: 16px;
 font-weight: 400;
 color: #4e4e4e;
`;

const DetailValue = styled.div`
 font-size: 16px;
 font-weight: 700;
 color: #0a0a0a;
`;
